<template>
    <div class="col-12 fetchedText">
        <div class="table-fluid">
            <ul
                class="search-table"
                v-for="(nnyafter,index) in NnyLemAfter"
                v-if="NnyLemAfter"
                :key="nnyafter.text+'-'+index">
                <li class="col-12">
                    <dl class="row">
                        <dt
                            class="col-6 col-lg-3 col-sm-4 bold-text"
                            v-bind:class="[isPictureView ? 'backgrd':'' ]"
                        >
                            <span class="dynamic">{{ $t('message.nynorsk') }}</span>
                            <span
                                v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
                            >{{ $t('message.lemma') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                            data-type="LEM"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <template v-if="hasNorskOrdbank('nno')">
                                <NorskOrdbankResultPronunciation
                                    :norskOrdbank="getNorskOrdbank('nno')"
                                    :lemValue="getOrdbankLemValue('nno')"
                                    :searchWord="getSearchWord()"
                                />
                            </template>
                            <template v-else>
                                <b v-html="nnyafter.text" :ref="'link34'+index"></b>
                                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                    <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                         src="/images/speaker-small.svg">
                                </a>
                            </template>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="NnyUttAfter && index==index1" v-for="(utt,index1) in uttafter"
                    :key="utt+'-'+index1">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text"></dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text utt-text"
                            data-type="UTT"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <Pronunciation v-if="utt" :value="utt" />
                        </dd>
                    </dl>
                </li>
            </ul>
            <ul class="search-table">
                <li class="col-12" v-if="NnyLem">
                    <dl class="row">
                        <dt
                            class="col-6 col-lg-3 col-sm-4 bold-text"
                            v-bind:class="[isPictureView ? 'backgrd':'' ]"
                        >
                            <span class="dynamic">{{ $t('message.nynorsk') }}</span>
                            <span
                                v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
                            >{{ $t('message.lemma') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                            data-type="LEM"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <template v-if="hasNorskOrdbank('nno')">
                                <NorskOrdbankResultPronunciation
                                    :norskOrdbank="getNorskOrdbank('nno')"
                                    :lemValue="getOrdbankLemValue('nno')"
                                    :searchWord="getSearchWord()"
                                />
                            </template>
                            <template v-else>
                                <template v-for="nny_lem_text in NnyLem.text.split('&&')">
                                    <div class="lem-w-pron-icon">
                                        <b v-html="nny_lem_text" ref="link1"></b>&nbsp;
                                        <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                            <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                                 src="/images/speaker-small.svg">
                                        </a>
                                    </div>
                                </template>
                            </template>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="NnyUtt && !hasNorskOrdbank('nno')">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text"></dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text utt-text"
                            data-type="UTT"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <template v-if="NnyUtt.text.includes('&&')" v-for="(uttVal, uttIndex) in NnyUtt.text.split('&&')"><span class="separator" v-if="uttIndex > 0">, </span><Pronunciation v-if="uttVal" :value="uttVal" /></template>
                            <Pronunciation v-else-if="NnyUtt || false" :value="NnyUtt.text" />
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="bLem">
                    <dl class="row">
                        <dt
                            class="col-6 col-lg-3 col-sm-4 bold-text"
                            v-bind:class="[isPictureView ? 'backgrd':'' ]"
                        >
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="NnyLem===undefined"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
                            >{{ $t('message.lemma') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text"
                            data-type="LEM"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                        >
                            <b v-html="bLem.text" ref="link3"></b>&nbsp;
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="lastLem">
                    <dl class="row">
                        <dt
                            class="col-6 col-lg-3 col-sm-4 bold-text"
                            v-bind:class="[isPictureView ? 'backgrd':'' ]"
                            style="text-transform: capitalize;"
                        >
                            <span class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 font-thin"
                            data-type="LEM"
                            :lang="languageCodeList.find(x=>x.lang==lastLem.lang).langISOCode"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                        >
                            <template v-if="hasNorskOrdbank('nob')">
                                <NorskOrdbankResultPronunciation
                                    :norskOrdbank="getNorskOrdbank('nob')"
                                    :lemValue="getOrdbankLemValue('nob')"
                                    :searchWord="getSearchWord()"
                                />
                            </template>
                            <template v-else>
                                <b v-html="lastLem.text" ref="link5"></b>
                                <a role="button" href="javascript:void(0)"
                                   v-if="lastLem.lang === 'N' || lastLem.lang === 'E'" onclick="javascript:tts(this);" tabindex="0">
                                    <img
                                        class="pointer speaker-image"
                                        :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                    >
                                </a>
                            </template>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="lastUtt && lastLem && !hasNorskOrdbank('nob')">
                    <dl class="row">
                        <dt class="col-lg-3 col-sm-4 col-6 bold-text"></dt>
                        <dd
                            class="col-lg-9 col-sm-8 col-6 nor-text utt-text"
                            data-type="UTT"
                            :lang="languageCodeList.find(x=>x.lang==lastUtt.lang).langISOCode"
                        >
                            <Pronunciation v-if="lastUtt || false" :value="lastUtt.text" />
                        </dd>
                    </dl>
                </li>
                <li class="ordbank-boyning" v-if="hasLanguageContent(NnyLem)" lang="nn">
                    <hr />
                    <NorskOrdbankResultBlocks
                        :initialBlockInfo="getOrdbankInitialBlockInfo('nno')"
                        :showLiContent="true"
                        :defaultOpen="getDefaultOrdbankOpen(NnyLem, lastLem)"
                    />
                </li>
                <li class="col-12" v-if="bKat">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">{{ $t('message.english') }}</dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text"
                            data-type="KAT"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            ref="link4"
                        >
                            <PartOfSpeachHeader
                                v-if="hasTextProperty(bLem)"
                                :snId="getSnId()"
                                :lemInfo="bLem"
                                :katInfo="bKat"
                                :partOfSpeachInfo="partOfSpeachInfo"
                                :norskOrdbank="getNorskOrdbank('nno')"
                            />
                        </dd>
                    </dl>
                </li>
                <li
                    class="ordbank-boyning"
                    :lang="getLangAttribute('last')"
                    v-if="showLastOrdbank()"
                    >
                    <NorskOrdbankResultBlocks
                        :initialBlockInfo="getOrdbankInitialBlockInfo('last')"
                        :showLiContent="true"
                        :showInflectionHeader="false"
                        :defaultOpen="getDefaultOrdbankOpen(NnyLem, lastLem)"
                        :secondLang="secondLang"
                    />
                </li>
                <template v-if="!hasNorskOrdbank('nno')">
                <li class="col-12" v-if="NnyAlt" v-for="(alts,index) in NnyAlt" :key="alts.text+'-'+index">
                    <hr />
                    <dl
                        class="row"
                        v-if="alts.text.includes('&&')"
                        v-for="(alt,index1) in alts.text.split('&&').filter(x=>x.match('[^ -]')&& x.length != 0).reverse()"
                        :key="alt+'-'+index1"
                    >
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span v-if="index1==0" class="dynamic">{{ $t('message.nynorsk') }}</span>
                            <span
                                v-if="index==0 && index1===0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.alternative') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                            data-type="ALT"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <span v-html="alt" ref="link7"></span>
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else>
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ $t('message.nynorsk') }}</span>
                            <span
                                v-if="index==0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.alternative') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                            data-type="ALT"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <span v-html="alts.text" ref="link7"></span>
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                </template>
                <li class="col-12" v-if="bAlt">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                            data-type="ALT"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="bAlt.text"
                            ref="link8"
                        >
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <template v-if="!hasNorskOrdbank('nob')">
                    <li class="col-12" v-if="lastAlt">
                        <dl class="row">
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                                <span class="dynamic">{{ secondLang }}</span>
                                <span
                                    v-if="(lastAlt.lang === 'N' || lastAlt.lang === 'E') && !NnyAlt.length"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.alternative') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 clsE"
                                v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                                data-type="ALT"
                                :lang="languageCodeList.find(x=>x.lang==lastAlt.lang).langISOCode"
                            >
                                <span v-html="lastAlt.text" ref="link9"></span>
                                <a role="button" href="javascript:void(0)"
                                   v-if="lastAlt.lang === 'N' || lastAlt.lang === 'E'" onclick="javascript:tts(this);" tabindex="0">
                                    <img
                                        class="pointer speaker-image"
                                        :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                    >
                                </a>
                            </dd>
                        </dl>
                    </li>
                </template>
                <li class="col-12" v-if="bMor">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                            :data-lemma='bLem'
                            data-type="MOR"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="bMor.text"
                            ref="link11"
                        >
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="lastMor && getIsNonNorwegian()">
                    <div :class="getRedClassIfNonNorwegian(lastLem)">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 clsE"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="MOR"
                            :data-lemma='lastLem'
                            :lang="languageCodeList.find(x=>x.lang==lastMor.lang).langISOCode"
                        >
                            <span v-if="lastMor.lang === 'N' || lastMor.lang === 'E'"
                                  v-html="'['+lastMor.text+']'" ref="link12">
                            </span>
                            <span v-else v-html="lastMor.text" ref="link12"></span>
                            <a role="button" href="javascript:void(0)"
                               v-if="lastMor.lang === 'N' || lastMor.lang === 'E'" onclick="javascript:tts(this);" tabindex="0">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                    </div>
                </li>
                <li class="col-12" v-if="NnyKom">
                    <hr />
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ $t('message.nynorsk') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.comment') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                            data-type="KOM"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <span v-html="NnyKom.text" ref="link13"></span>
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="bKom">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                            <span
                                v-if="NnyKom===undefined"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.comment') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                            data-type="KOM"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="bKom.text"
                            ref="link14"
                        >
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="lastKom">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 clsE"
                            data-type="KOM"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            :lang="languageCodeList.find(x=>x.lang==lastKom.lang).langISOCode"
                        >
                            <span v-html="lastKom.text" ref="link15"></span>
                            <a role="button" href="javascript:void(0)"
                               v-if="lastKom.lang === 'N' || lastKom.lang === 'E'" onclick="javascript:tts(this);" tabindex="0">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="NnyGrm">
                    <hr />
                    <dl
                        class="row"
                        v-if="NnyGrm.text.includes('&&')"
                        v-for="(nnygrm,index) in NnyGrm.text.split('&&').filter(x=>x.match('[^ -]')).reverse().filter(function(el) {return el.length != 0})"
                        :key="nnygrm+'-'+index"
                    >
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span v-if="index===0 " class="dynamic">{{ $t('message.nynorsk') }}</span>
                            <span
                                class="reg-text"
                                v-if="index===0 "
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.grammar') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                            data-type="GRM"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <span v-html="nnygrm" ref="link16"></span>
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else>
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ $t('message.nynorsk') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.grammar') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                            data-type="GRM"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <span v-html="NnyGrm.text" ref="link16"></span>
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="bGrm">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                            data-type="GRM"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="bGrm.text"
                            ref="link17"
                        >
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="lastGrm">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 clsE"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="GRM"
                            :lang="languageCodeList.find(x=>x.lang==lastGrm.lang).langISOCode"
                        >
                            <span v-html="lastGrm.text" ref="link18"></span>
                            <a role="button" href="javascript:void(0)"
                               v-if="lastGrm.lang === 'N' || lastGrm.lang === 'E'" onclick="javascript:tts(this);" tabindex="0">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="NnyDef">
                    <hr />
                    <dl
                        class="row"
                        v-if="((NnyDef.text.includes('&&')))"
                        v-for="(nnydef,index) in NnyDef.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
                        :key="nnydef+'-'+index"
                    >
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span v-if="index === 0" class="dynamic">{{ $t('message.nynorsk') }}</span>
                            <span
                                class="reg-text"
                                v-if="index===0"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.explanation') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsN"
                            data-type="DEF"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <span v-html="nnydef" :ref="'link36'+index"></span>
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else>
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ $t('message.nynorsk') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.explanation') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsN"
                            data-type="DEF"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <span v-html="NnyDef.text" ref="link19"></span>
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="bDef">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text"
                            data-type="DEF"
                            v-html="bDef.text"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            ref="link20"
                        ></dd>
                    </dl>
                </li>
                <li class="col-12" v-if="lastDef">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8"
                            data-type="DEF"
                            :lang="languageCodeList.find(x=>x.lang==lastDef.lang).langISOCode"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                        >
                            <span v-html="lastDef.text" ref="link21"></span>
                            <a role="button" href="javascript:void(0)"
                               v-if="lastDef.lang === 'N' || lastDef.lang === 'E'" onclick="javascript:tts(this);" tabindex="0">
                                <img
                                    class="pointer speaker-image"
                                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="NnyTil">
                    <dl
                        class="row"
                        v-if="((NnyTil.text.includes('&&')))"
                        v-for="(nnytil,index) in NnyTil.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
                        :key="nnytil+'-'+index"
                    >
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span v-if="index===0" class="dynamic">{{ $t('message.nynorsk') }}</span>
                            <span
                                v-if="index===0"
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.addition') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsN"
                            data-type="TIL"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <span v-html="nnytil" ref="link22"></span>
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                    <dl class="row" v-else>
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ $t('message.nynorsk') }}</span>
                            <span
                                class="reg-text"
                                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                            >{{ $t('message.addition') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsN"
                            data-type="TIL"
                            :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                        >
                            <span v-html="NnyTil.text" ref="link22"></span>
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="bTil">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ $t('message.english') }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 nor-text clsN"
                            data-type="TIL"
                            :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                            v-html="bTil.text"
                            ref="link23"
                        >
                            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                     src="/images/speaker-small.svg">
                            </a>
                        </dd>
                    </dl>
                </li>
                <li class="col-12" v-if="lastTil">
                    <dl class="row">
                        <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                            <span class="dynamic">{{ secondLang }}</span>
                        </dt>
                        <dd
                            class="col-6 col-lg-9 col-sm-8 clsN"
                            v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                            data-type="TIL"
                            :lang="languageCodeList.find(x=>x.lang==lastTil.lang).langISOCode"
                        >
                            <span v-html="lastTil.text" ref="link24"></span>
                            <a role="button" href="javascript:void(0)"
                               v-if="lastTil.lang === 'N' || lastTil.lang === 'E'" onclick="javascript:tts(this);" tabindex="0">
                                <img class="pointer speaker-image"
                                     :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                >
                            </a>
                        </dd>
                    </dl>
                </li>
                <hr v-if="eks.length || idi.length || sms.length">
                <li class="col-12" v-for="(eks,index) in eks" :key="eks.text+'-'+index" v-if="eks.text != ''">
                    <hr v-if="!eks.showHeader && showDynamicHrInList(eks)" class="dyn-divider">
                    <div v-if="((eks.lang==='NNY') && (eks.text.includes('&&')))">
                        <dl
                            class="row"
                            v-for="(ekss,index1) in eks.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
                            :key="ekss+'-'+index1"
                        >
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                                <span v-if="index1 === 0" class="dynamic">{{ $t('message.nynorsk') }}</span>
                                <span
                                    v-if="index1 === 0 && index===0"
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.example') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="EKS"
                                :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                            >
                                <span v-html="ekss.replace('~','|')" ref="link37"></span>
                                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                    <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                         src="/images/speaker-small.svg">
                                </a>
                            </dd>
                        </dl>
                    </div>
                    <div v-else>
                        <dl class="row" v-if="eks.lang==='NNY'">
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                                <span class="dynamic">{{ $t('message.nynorsk') }}</span>
                                <span
                                    v-if="index === 0"
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.example') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="EKS"
                                :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                            >
                                <span v-html="eks.text" ref="link25"></span>
                                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                    <img
                                        class="pointer speaker-image"
                                        :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                    >
                                </a>
                            </dd>
                        </dl>
                        <dl class="row" v-if="eks.lang==='B'">
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                                <span class="dynamic">{{ $t('message.english') }}</span>
                                <span
                                    v-if="index === 0"
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.example') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="EKS"
                                :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                                v-html="eks.text"
                                ref="link26"
                            >
                                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                    <img
                                        class="pointer speaker-image"
                                        :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                    >
                                </a>
                            </dd>
                        </dl>
                        <dl class="row" v-else-if="((eks.lang !=='B') && (eks.lang !=='NNY'))">
                            <dt
                                class="col-6 col-lg-3 col-sm-4 bold-text"
                                style="text-transform: capitalize;"
                            >
                                <span class="dynamic">{{ secondLang }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 clsE"
                                v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                                data-type="EKS"
                                :lang="languageCodeList.find(x=>x.lang==eks.lang).langISOCode"
                            >
                                <span v-html="eks.text" ref="link27"></span>
                                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                    <img
                                        v-if="eks.lang === 'N' || eks.lang === 'E'"
                                        class="pointer speaker-image"
                                        :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                    >
                                </a>
                            </dd>
                        </dl>
                    </div>
                </li>
                <hr v-if="(eks.length && idi.length) || (eks.length && sms.length)">
                <li class="col-12" v-for="(idi,index) in idi" :key="idi.text+'-'+index" v-if="idi.text !== ''">
                    <hr v-if="!idi.showHeader && showDynamicHrInList(idi)" class="dyn-divider">
                    <div v-if="((idi.lang==='NNY') && (idi.text.includes('&&')))">
                        <dl
                            class="row"
                            v-for="(idis,index1) in idi.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
                            :key="idis+'-'+index1"
                        >
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                                <span v-if="index1 === 0" class="dynamic">{{ $t('message.nynorsk') }}</span>
                                <span
                                    v-if="idi.showHeader && index1 === 0"
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.expression') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="IDI"
                                :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                            >
                                <span v-html="idis.replace('~','|')" ref="link38"></span>
                                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                    <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                         src="/images/speaker-small.svg">
                                </a>
                            </dd>
                        </dl>
                    </div>
                    <div v-else>
                        <dl class="row" v-if="idi.lang==='NNY'">
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                                <span class="dynamic">{{ $t('message.nynorsk') }}</span>
                                <span
                                    v-if="idi.showHeader"
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.expression') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="IDI"
                                :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                            >
                                <span v-html="idi.text" ref="link28"></span>
                                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                    <img
                                        class="pointer speaker-image"
                                        :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
                                </a>
                            </dd>
                        </dl>
                        <dl class="row" v-if="idi.lang==='B'">
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                                <span class="dynamic">{{ $t('message.english') }}</span>
                                <span
                                    v-if="index === 0"
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.expression') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="IDI"
                                :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                                v-html="idi.text"
                                ref="link29"
                            >
                                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                    <img
                                        class="pointer speaker-image"
                                        :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                    >
                                </a>
                            </dd>
                        </dl>
                        <dl class="row" v-else-if="((idi.lang!=='B') && (idi.lang!='NNY'))">
                            <dt
                                class="col-6 col-lg-3 col-sm-4 bold-text"
                                style="text-transform: capitalize;"
                            >
                                <span class="dynamic">{{ secondLang }}</span>
                                <span
                                    v-if="idi.showHeader"
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.expression') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 clsE"
                                v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                                data-type="IDI"
                                :lang="languageCodeList.find(x=>x.lang==idi.lang).langISOCode"
                            >
                                <span v-html="idi.text" ref="link30"></span>
                                <a role="button" href="javascript:void(0)" v-if="idi.lang === 'N' || idi.lang === 'E'"
                                   onclick="javascript:tts(this);" tabindex="0">
                                    <img
                                        class="pointer speaker-image"
                                        :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                    >
                                </a>
                            </dd>
                        </dl>
                    </div>
                </li>
                <hr v-if="idi.length && sms.length">
                <li class="col-12" v-for="(sms,index) in sms" :key="sms.text+'-'+index" v-if="sms.text != ''">
                    <hr v-if="!sms.showHeader && showDynamicHrInList(sms)" class="dyn-divider">
                    <div v-if="((sms.lang==='NNY') && (sms.text.includes('&&')))">
                        <dl
                            class="row"
                            v-for="(smss,index1) in sms.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
                            :key="smss+'-'+index1"
                        >
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                                <span v-if="index1 === 0" class="dynamic">{{ $t('message.nynorsk') }}</span>
                                <span
                                    v-if="index1 === 0 && index===0"
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.multiword') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="SMS"
                                :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                            >
                                <span v-html="smss" ref="link40"></span>
                                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                    <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')"
                                         src="/images/speaker-small.svg">
                                </a>
                            </dd>
                        </dl>
                    </div>
                    <div v-else>
                        <dl class="row" v-if="sms.lang==='NNY'">
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                                <span class="dynamic">{{ $t('message.nynorsk') }}</span>
                                <span
                                    v-if="index === 0 "
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.multiword') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="SMS"
                                :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
                            >
                                <span v-html="sms.text" ref="link31"></span>
                                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                    <img
                                        class="pointer speaker-image"
                                        :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                    >
                                </a>
                            </dd>
                        </dl>
                        <dl class="row" v-if="sms.lang==='B'">
                            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                                <span class="dynamic">{{ $t('message.english') }}</span>
                                <span
                                    v-if="index === 0"
                                    class="reg-text"
                                    v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                                >{{ $t('message.multiword') }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                                data-type="SMS"
                                :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                                v-html="sms.text"
                                ref="link32"
                            >
                                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);" tabindex="0">
                                    <img
                                        class="pointer speaker-image"
                                        :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                                    >
                                </a>
                            </dd>
                        </dl>
                        <dl class="row" v-else-if="((sms.lang!=='B') && (sms.lang !== 'NNY'))">
                            <dt
                                class="col-6 col-lg-3 col-sm-4 bold-text"
                                style="text-transform: capitalize;"
                            >
                                <span class="dynamic">{{ secondLang }}</span>
                            </dt>
                            <dd
                                class="col-6 col-lg-9 col-sm-8 clsE"
                                v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                                data-type="SMS"
                                :lang="languageCodeList.find(x=>x.lang==sms.lang).langISOCode"
                            >
                                <span v-html="sms.text" :ref="'link33'+index"></span>
                                <a role="button" href="javascript:void(0)" v-if="sms.lang === 'N' || sms.lang === 'E'"
                                   onclick="javascript:tts(this);" tabindex="0">
                                    <img
                                        class="pointer speaker-image"
                                        src="/images/speaker-small.svg"
                                    >
                                </a>
                            </dd>
                        </dl>
                    </div>
                </li>
                <hr class="bdr-set">
            </ul>
        </div>
    </div>
</template>
<script>

import norskOrdbankResult from "@/components/NorskOrdbankResult.vue";
import NorskOrdbankResultBlocks from "@/components/NorskOrdbankResultBlocks.vue";
import NorskOrdbankResultPronunciation from "@/components/NorskOrdbankResultPronunciation.vue";
import Pronunciation from "@/components/Pronunciation.vue";
import PartOfSpeachHeader from "@/components/PartOfSpeachHeader.vue";


export default {
    name: "pictureResultNny",
    components: {
        NorskOrdbankResultPronunciation,
        norskOrdbankResult,
        NorskOrdbankResultBlocks,
        Pronunciation,
        PartOfSpeachHeader,
    },
    data() {
        return {
            cache: {},
            hrInListCache: [],
            xres: null,
            NnyLem: {},
            NnyLemAfter: [],
            NnyKat: {},
            NnyDef: {},
            NnyKom: {},
            NnyTil: {},
            NnyMor: {},
            NnyAlt: [],
            NnyUtt: {},
            NnyUttAfter: {},
            NnyGrm: {},
            bLem: {},
            bKat: {},
            bDef: {},
            bKom: {},
            bTil: {},
            bMor: {},
            bAlt: {},
            bGrm: {},
            lastLem: {},
            lastkat: {},
            lastDef: {},
            lastKom: {},
            lastTil: {},
            lastMor: {},
            lastAlt: {},
            lastUtt: {},
            lastGrm: {},
            sms: [],
            eks: [],
            idi: [],
            arrStr: [],
            imgs: [],
            uttafter: [],
            isLeftAllign: false,
            isPictureView: false,
            refElements: [],
            languageCodeList: [
                {language: 'bokmal', lang: 'E', langISOCode: 'nb'},
                {language: 'bokmal', lang: 'N', langISOCode: 'nb'},
                {language: 'nynorsk', lang: 'NNY', langISOCode: 'nn'},
                {language: 'arabic', lang: 'ARA', langISOCode: 'ar'},
                {language: 'dari', lang: 'PRS', langISOCode: 'prs'},
                {language: 'burmese', lang: 'BUR', langISOCode: 'my'},
                {language: 'kurdish (kurmanji)', lang: 'KKU', langISOCode: 'kmr'},
                {language: 'kurdish (sorani)', lang: 'KSO', langISOCode: 'ckb'},
                {language: 'lithuanian', lang: 'LIT', langISOCode: 'lt'},
                {language: 'persian', lang: 'PER', langISOCode: 'fa'},
                {language: 'polish', lang: 'POL', langISOCode: 'pl'},
                {language: 'russian', lang: 'RU', langISOCode: 'ru'},
                {language: 'somali', lang: 'SOM', langISOCode: 'so'},
                {language: 'tagalog', lang: 'TGL', langISOCode: 'tl'},
                {language: 'tamil', lang: 'T', langISOCode: 'ta'},
                {language: 'thai', lang: 'TH', langISOCode: 'th'},
                {language: 'tigrinya', lang: 'TIR', langISOCode: 'ti'},
                {language: 'turkish', lang: 'TUR', langISOCode: 'tr'},
                {language: 'ukrainsk', lang: 'UKR', langISOCode: 'uk'},
                {language: 'ukrainian', lang: 'UKR', langISOCode: 'uk'},
                {language: 'urdu', lang: 'UR', langISOCode: 'ur'},
                {language: 'vietnamese', lang: 'VIE', langISOCode: 'vi'},
                {language: 'english', lang: 'B', langISOCode: 'en'}
            ]
        };
    },
    props: {
        Val: Array,
        lang: String,
        secondLang: String,
        displayLang: String,
        loaded: Boolean,
        dictionary: String,
        ordbankList: Object,
        partOfSpeachInfo: Object,
        resultIndex: String,
        isPicturepage: Boolean,
        includeEngLanguage: Boolean,
        searchInput: {
            type: String,
            default: ""
        }
    },
    mounted() {
        if (this.searchInput === "" || this.searchInput === null) {
            this.isPictureView = true;
        }
        if (this.displayLang === "nynorsk") {
            Array.from(document.querySelectorAll(".dynamic")).forEach(
                a => (a.style.display = "none")
            );
        }
        this.refElements = this.$refs;
        this.addOnClickToHyperlink();
    },
    created() {
        if (this.Val.length) {
            this.xres = this.Val;
            this.mapIntoHtml();
        }
    },
    updated() {
        if (this.displayLang === "nynorsk") {
            Array.from(document.querySelectorAll(".dynamic")).forEach(
                a => (a.style.display = "none")
            );
        }
        this.refElements = this.$refs;
        this.addOnClickToHyperlink();
    },
    watch: {
        Val: function (newVal) {
            this.xres = newVal;
            this.mapIntoHtml();
        }
    },
    methods: {
        //#region function to filter the data into the different objects according to the different types
        //words are mapped to the correct object i.e.eLem,eKat....  based on there type
        filterData(lang) {
            var _this = this;
            this.NnyLem = lang.find(function (obj) {
                // if (obj.text.includes("&&")) {
                //     var index = obj.text.indexOf("&");
                //     if (index > 0) obj.text = obj.text.substring(0, index);
                // }
                return obj.type === "Nny-lem";
            });
            // this.NnyLemAfter = _.filter(lang, function (item) {
            //     return _.includes(item.type, "Nny-lemafter") && item.text.length > 0;
            // });

            this.NnyKat = lang.find(function (obj) {
                return obj.type === "Nny-kat" && obj.text.length > 0;
            });
            if (this.NnyKat === undefined) {
                this.NnyKat = lang.find(function (obj) {
                    return (obj.type === "E-kat" || obj.type === "N-kat") && obj.text.length > 0;
                });
            }
            this.NnyDef = lang.find(function (obj) {
                return obj.type === "Nny-def" && obj.text.length > 0;
            });
            this.NnyKom = lang.find(function (obj) {
                if (obj.type == "Nny-kom" && obj.text.match(/^[a-z]+[-]+[0-9]*$/g)) {
                } else {
                    return obj.type === "Nny-kom" && obj.text.length > 0;
                }
            });
            this.NnyTil = lang.find(function (obj) {
                return obj.type === "Nny-til" && obj.text.length > 0;
            });
            this.NnyMor = lang.find(function (obj) {
                return obj.type === "Nny-mor" && obj.text.length > 0;
            });

            this.NnyAlt = _.filter(lang, function (item) {
                return _.includes(item.type, "Nny-alt") && item.text.length > 0;
            });
            this.NnyUtt = lang.find(function (obj) {
                return obj.type === "Nny-utt" && obj.text.length > 0;
            });
            this.NnyUttAfter = lang.find(function (obj) {
                if (obj.text.includes("&&")) {
                    return obj.type === "Nny-utt" && obj.text.length > 0;
                }
            });
            this.NnyGrm = lang.find(function (obj) {
                return obj.type === "Nny-grm" && obj.text.length > 0;
            });
            this.bLem = lang.find(function (obj) {
                return obj.type === "B-lem" && obj.text.length > 0;
            });
            this.bKat = lang.find(function (obj) {
                return obj.type === "B-kat" && obj.text.length > 0;
            });
            this.bDef = lang.find(function (obj) {
                return obj.type === "B-def" && obj.text.length > 0;
            });
            this.bKom = lang.find(function (obj) {
                if (obj.type == "B-kom" && obj.text.match(/^[a-z]+[-]+[0-9]*$/g)) {
                } else {
                    return obj.type === "B-kom" && obj.text.length > 0;
                }
            });
            this.bTil = lang.find(function (obj) {
                return obj.type === "B-til" && obj.text.length > 0;
            });
            this.bMor = lang.find(function (obj) {
                return obj.type === "B-mor" && obj.text.length > 0;
            });
            this.bAlt = lang.find(function (obj) {
                return obj.type === "B-alt" && obj.text.length > 0;
            });
            this.bGrm = lang.find(function (obj) {
                return obj.type === "B-grm" && obj.text.length > 0;
            });

            this.lastLem = lang.find(function (obj) {
                if (
                    obj.lang == "UR" ||
                    obj.lang == "ARA" ||
                    obj.lang == "KSO" ||
                    obj.lang == "PER" ||
                    obj.lang == "PRS"
                ) {
                    _this.isLeftAllign = true;
                }
                return (
                    obj.type !== "B-lem" &&
                    obj.type !== "Nny-lem" &&
                    obj.type !== "Nny-lemafter" &&
                    obj.type.indexOf("lem") > 0 &&
                    obj.text.length > 0
                );
            });
            this.lastkat = lang.find(function (obj) {
                return (
                    obj.type !== "B-kat" &&
                    obj.type !== "Nny-kat" &&
                    obj.type.indexOf("kat") > 0 &&
                    obj.text.length > 0
                );
            });
            this.lastDef = lang.find(function (obj) {
                return (
                    obj.type !== "B-def" &&
                    obj.type !== "Nny-def" &&
                    obj.type.indexOf("def") > 0 &&
                    obj.text.length > 0
                );
            });

            this.lastKom = lang.find(function (obj) {
                if (
                    obj.type !== "B-kom" &&
                    obj.type !== "Nny-kom" &&
                    obj.type.indexOf("kom") > 0 &&
                    obj.text.match(/^[a-z]+[-]+[0-9]*$/g)
                ) {
                } else {
                    return (
                        obj.type !== "B-kom" &&
                        obj.type !== "Nny-kom" &&
                        obj.type.indexOf("kom") > 0 &&
                        obj.text.length > 0
                    );
                }
            });
            this.lastTil = lang.find(function (obj) {
                return (
                    obj.type !== "B-til" &&
                    obj.type !== "Nny-til" &&
                    obj.type.indexOf("til") > 0 &&
                    obj.text.length > 0
                );
            });
            this.lastMor = lang.find(function (obj) {
                return (
                    obj.type !== "B-mor" &&
                    obj.type !== "Nny-mor" &&
                    obj.type.indexOf("mor") > 0 &&
                    obj.text.length > 0
                );
            });
            this.lastAlt = lang.find(function (obj) {
                return (
                    obj.type !== "B-alt" &&
                    obj.type !== "Nny-alt" &&
                    obj.type.indexOf("alt") > 0 &&
                    obj.text.length > 0
                );
            });
            this.lastUtt = lang.find(function (obj) {
                return (
                    obj.type !== "B-utt" &&
                    obj.type !== "Nny-utt" &&
                    obj.type.indexOf("utt") > 0 &&
                    obj.text.length > 0
                );
            });
            this.lastGrm = lang.find(function (obj) {
                return (
                    obj.type !== "B-grm" &&
                    obj.type !== "Nny-grm" &&
                    obj.type.indexOf("grm") > 0 &&
                    obj.text.length > 0
                );
            });

            this.sms = this.filterDynamicValues('sms', lang);
            this.eks = this.filterDynamicValues('eks', lang);
            this.idi = this.filterDynamicValues('idi', lang);

            if (this.NnyUttAfter != undefined) {
                this.getUttAfterText(this.NnyUttAfter.text);
            }
        },
        //#endregion

        filterDynamicValues(fieldName, lang) {
            let langList = [];

            let values = _.filter(lang, function (item) {
                const hasInclude = _.includes(item.type, "-" + fieldName);
                if (hasInclude && !langList.includes(item.lang)) {
                    langList.push(item.lang);
                }
                return hasInclude;
            });

            values = _.sortBy(values, function (o) {
                return o.sub_id;
            });

            values = this.getDistinctValue(values, langList);

            return values;
        },

        //#region function to create separate array for all the utt words contains in text if it contains &&
        getUttAfterText(text) {
            if (text.includes("&&")) {
                var a = text.split("&&");
                if (a.length > 1) {
                    for (var i = 1; i < a.length; i++) {
                        this.uttafter.push(a[i]);
                    }
                }
            }
        },
        //#endregion

        sortDistinctValue(list) {
            list.sort((a, b) => {
                if (a.index > b.index) {
                    return 1;
                } else if (a.index === b.index) {
                    if (a.sub_id !== undefined && b.sub_id !== undefined) {
                        if (a.sub_id > b.sub_id) {
                            return 1;
                        } else {
                            return -1;
                        }
                    } else {
                        return -1;
                    }
                } else {
                    return -1;
                }
            });

            return list;
        },

        //#region function to reorder the text of type sms,idi,eks according to the sub_id,first-language and second-language
        getDistinctValue(val, langListValues = []) {
            if (!val) {
                return;
            }

            let arr_result = [];
            let nny = [],
                eng = [],
                last_lang = [],
                hasLangNny = false,
                hasLangEng = false,
                langOtherValue = '';

            if (langListValues.includes('B')) {
                hasLangEng = true;
            }

            if (langListValues.includes('NNY')) {
                hasLangNny = true;
            }

            for (let i in langListValues) {
                if (!(['NNY', 'B'].includes(langListValues[i]))) {
                    langOtherValue = langListValues[i];
                    if (langOtherValue === 'E' || langOtherValue === 'N') {
                        langOtherValue = 'N';
                    }
                }
            }

            let langIndexMap = {};
            for (let i in val) {
                if (val[i]['index'] !== undefined && typeof val[i]['index'] === 'number' ) {
                    let lang = val[i]['lang'];
                    let index = val[i]['index'];
                    if (langIndexMap[lang] === undefined) {
                        langIndexMap[lang] = {};
                    }
                    langIndexMap[lang][index] = true;
                }
            }

            let nnyHasIndex = false;
            let engHasIndex = false;
            let otherHasIndex = false;

            let rowIndex = 0;
            let firstLangList = [];
            let langList = {};
            let hasNny = false;
            for (let i = 0; i < val.length; i++) {
                if (val[i].lang !== undefined) {
                    let lang = val[i].lang;
                    if (!firstLangList.length) {
                        // Nynorsk should always be the first value.
                        // lang is always uppercase.
                        if (langOtherValue === 'N' && (val[i].lang === 'E' || val[i].lang === 'N')) {
                            firstLangList.push('N');
                            firstLangList.push('E');
                            hasNny = true;
                        } else if (val[i].lang === 'NNY') {
                            firstLangList.push('NNY');
                            hasNny = true;
                        }
                    } else if (firstLangList.includes(val[i].lang)) {
                        if (hasLangNny && langList[rowIndex]['NNY'] === undefined &&
                            !this.hasLangIndexMap(langIndexMap, 'NNY', rowIndex)) {
                            let langListInfo = this.getLangListInfoFromLangListRow('NNY', langList[rowIndex]);
                            if (langListInfo) {
                                let langIndex = langListInfo['index'];
                                let itemRowIndex = rowIndex;
                                if (langIndexMap['NNY'] !== undefined) {
                                    itemRowIndex = this.getFirstFreeRowIndex(langIndexMap['NNY'], rowIndex);
                                    langIndexMap['NNY'][itemRowIndex] = true;
                                    langIndex = itemRowIndex;
                                }

                                langList[itemRowIndex]['NNY'] = {
                                    'entry': langListInfo['entry'],
                                    'id': langListInfo['id'],
                                    'index': langIndex,
                                    'lang': 'NNY',
                                    'text': '',
                                    'type': langListInfo['type']
                                }
                            }
                        }

                        if (hasLangEng && langList[rowIndex]['B'] === undefined &&
                            !this.hasLangIndexMap(langIndexMap, 'B', rowIndex)) {
                            let langListInfo = this.getLangListInfoFromLangListRow('B', langList[rowIndex]);
                            if (langListInfo) {

                                let langIndex = langListInfo['index'];
                                let itemRowIndex = rowIndex;
                                if (langIndexMap['B'] !== undefined) {
                                    itemRowIndex = this.getFirstFreeRowIndex(langIndexMap['B'], rowIndex);
                                    langIndexMap['B'][itemRowIndex] = true;
                                    langIndex = itemRowIndex;
                                }

                                langList[itemRowIndex]['B'] = {
                                    'entry': langListInfo['entry'],
                                    'id': langListInfo['id'],
                                    'index': langIndex,
                                    'lang': 'B',
                                    'text': '',
                                    'type': langListInfo['type']
                                }
                            }
                        }

                        if (langOtherValue !== '' &&
                            !['NNY', 'B'].includes(langOtherValue) &&
                            langList[rowIndex][langOtherValue] === undefined &&
                            !this.hasLangIndexMap(langIndexMap, langOtherValue, rowIndex)) {
                            let langListInfo = this.getLangListInfoFromLangListRow(langOtherValue, langList[rowIndex]);
                            if (langListInfo) {
                                let currentLang = val[i].lang;
                                if (currentLang === 'E') {
                                    currentLang = 'N';
                                }

                                let langIndex = langListInfo['index'];
                                let itemRowIndex = rowIndex;
                                if (langIndexMap[langOtherValue] !== undefined) {
                                    itemRowIndex = this.getFirstFreeRowIndex(langIndexMap[langOtherValue], rowIndex);
                                    langIndexMap[langOtherValue][itemRowIndex] = true;
                                    langIndex = itemRowIndex;
                                }

                                langList[itemRowIndex][langOtherValue] = {
                                    'entry': langListInfo['entry'],
                                    'id': langListInfo['id'],
                                    'index': langIndex,
                                    'lang': langOtherValue,
                                    'text': '',
                                    'type': langListInfo['type']
                                }
                            }
                        }

                        rowIndex = rowIndex + 1;
                    }

                    if (langList[rowIndex] === undefined) {
                        langList[rowIndex] = {};
                    }

                    if (hasNny) {
                        if (lang === 'E' || lang === 'N') {
                            lang = 'N';
                        }

                        if (typeof val[i].index === 'number') {
                            let subIndex = val[i].index;
                            if (langList[subIndex] === undefined) {
                                langList[subIndex] = {};
                            }
                            langList[subIndex][lang] = val[i];
                        } else if (langList[rowIndex][lang] === undefined) {
                            langList[rowIndex][lang] = val[i];
                        } else {
                            // console.log("Exclude: [Lexin: " + val[i].id + ": " + lang + "] '" + val[i].type + "' - " + val[i].sub_id + ": " + val[i].text, langList[rowIndex][lang]);
                        }
                    } else {
                        // console.log("do not have bookmal yet: "  + val[i].type + "' - " + val[i].sub_id + ": " + val[i].text);
                    }
                }
            }


            for (let index in langList) {
                let langCode = 'NNY';
                if (langList[index][langCode] !== undefined) {
                    nny.push(langList[index][langCode]);
                    if (langList[index][langCode].index !== undefined &&
                        typeof langList[index][langCode].index === 'number') {
                        nnyHasIndex = true;
                    }
                }

                langCode = 'B';
                if (langList[index][langCode] !== undefined) {
                    eng.push(langList[index][langCode]);
                    if (langList[index][langCode].index !== undefined &&
                        typeof langList[index][langCode].index === 'number') {
                        engHasIndex = true;
                    }
                }

                for (let langIndex in langList[index]) {
                    if (!['NNY', 'B'].includes(langIndex)) {
                        langCode = langIndex;
                        last_lang.push(langList[index][langCode]);
                        if (langList[index][langCode].index !== undefined &&
                            typeof langList[index][langCode].index === 'number') {
                            otherHasIndex = true;
                        }
                    }
                }
            }
            if (nnyHasIndex) {
                nny = this.sortDistinctValue(nny);
            }

            if (engHasIndex) {
                eng = this.sortDistinctValue(eng);
            }

            if (otherHasIndex) {
                last_lang = this.sortDistinctValue(last_lang);
            }

            let hasShowHeader = false;
            for (let i = 0; i < nny.length; i++) {
                let hasContent = false;
                if (nny[i].text !== undefined && nny[i].text) {
                    hasContent = true;
                } else if (eng[i] !== undefined && eng[i].text) {
                    hasContent = true;
                } else if (last_lang[i] !== undefined && last_lang[i].text) {
                    hasContent = true;
                }

                if (hasContent) {
                    if (nny[i] !== undefined) {
                        nny[i].showHr = false;
                        nny[i].showHeader = false;
                    }
                    if (eng[i] !== undefined) {
                        eng[i].showHr = false;
                        eng[i].showHeader = false;
                    }
                    if (last_lang[i] !== undefined) {
                        last_lang[i].showHr = false;
                        last_lang[i].showHeader = false;
                    }

                    if (nny[i].text) {
                        nny[i].showHr = true;
                        if (!hasShowHeader) {
                            nny[i].showHeader = true;
                            hasShowHeader = true;
                        }
                    } else if (eng[i] !== undefined && eng[i].text) {
                        eng[i].showHr = true;
                        if (!hasShowHeader) {
                            eng[i].showHeader = true;
                            hasShowHeader = true;
                        }
                    } else if (last_lang[i] !== undefined && last_lang[i].text) {
                        last_lang[i].showHr = true;
                        if (!hasShowHeader) {
                            last_lang[i].showHeader = true;
                            hasShowHeader = true;
                        }
                    } else {
                        nny[i].showHr = true;
                        if (!hasShowHeader) {
                            nny[i].showHeader = true;
                            hasShowHeader = true;
                        }
                    }

                    if (nny[i] !== undefined) {
                        arr_result.push(nny[i]);
                    }

                    if (eng[i] !== undefined) {
                        arr_result.push(eng[i]);
                    }

                    if (last_lang[i] !== undefined) {
                        arr_result.push(last_lang[i]);
                    }
                }
            }

            return arr_result;
        },
        getFirstFreeRowIndex(indexMap, rowIndex) {
            for (let j=0; j<indexMap.length; j++) {
                if (indexMap[j] === undefined) {
                    return j;
                }
            }

            return rowIndex;
        },
        hasLangIndexMap(langIndexMap, lang, rowIndex) {
            let value = false;
            if (langIndexMap[lang] !== undefined &&
                langIndexMap[lang][rowIndex] !== undefined &&
                langIndexMap[lang][rowIndex] === true) {
                value = true;
            }

            return value;
        },
        getLangListInfoFromLangListRow(langUppercase, langList) {
            if (Object.keys(langList).length > 0) {
                for (let lang in langList) {
                    const info = langList[lang];
                    const langCode = this.capitalizeFirstLetter(langUppercase.toLowerCase());
                    const langInfo = {
                        'entry': info['entry'],
                        'id': info['id'],
                        'index': info['index'],
                        'lang': langUppercase,
                        'text': '',
                        'type': langCode + '-' + info['entry'].toLowerCase()
                    }

                    return langInfo;
                }
            }

            return [];
        },
        capitalizeFirstLetter(str) {
            if (typeof str !== 'string' || str.length === 0) {
                return ''; // Handle empty strings or non-string inputs
            }
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        showDynamicHrInList(item) {
            if (item.lang === 'NNY') {
                return true;
            } else if (item.showHr !== undefined && item.showHr === true) {
                return true;
            }

            return false;
        },
        getOrdbankLemValue(languageCode) {
            let value = '';

            if (languageCode == 'nob') {
                if (this.lastLem != undefined) {
                    value = this.lastLem.text;
                }
            } else if (languageCode == 'nno') {
                if (this.lastLem != undefined) {
                    value = this.NnyLem.text;
                }
            }

            return value;
        },        //#endregion
        getSearchWord() {
            return this.searchInput.replace(/^\s+|\s+$/g, "").trim();
        },

        //#region  function to group all the records from data for particular id.
        mapIntoHtml() {
            var searchWord = this.searchInput.replace(/^\s+|\s+$/g, "").trim();
            var imagethemePage = false;
            if (this.searchInput == "") {
                imagethemePage = true;
            }
            var loaded = this.loaded;
            this.xres = _.map(this.xres, function (group) {
                var split = group.type.split("-");
                if (group.text.includes("||")) {

                } else if (group.text.includes("|")) {
                    group.text = group.text.split("|")[1];
                }
                return {
                    id: group.id,
                    sub_id: group.sub_id,
                    text: decode_utf8(
                        group.text,
                        split.length > 1 ? split[1].toUpperCase() : "",
                        imagethemePage,
                        loaded
                    ),
                    type: group.type,
                    index: group.index,
                    lang: split[0].toUpperCase(),
                    entry: split.length > 1 ? split[1].toUpperCase() : ""
                };
            });

            for (var i = 0; i < this.xres.length; i++) {
                var split = this.xres[i].type.split("-");
                if (
                    this.xres[i].text.includes("&&") &&
                    this.xres[i].type == "Nny-lem"
                ) {
                    var a = this.xres[i].text.split("&&");
                    if (a.length >= 2) {
                        for (var j = 1; j < a.length; j++) {
                            this.xres.push({
                                id: this.xres[i].id,
                                sub_id: this.xres[i].sub_id,
                                text: decode_utf8(
                                    a[j],
                                    split.length > 1 ? split[1].toUpperCase() : "",
                                    imagethemePage
                                ),
                                type: this.xres[i].type + "after",
                                lang: split[0].toUpperCase(),
                                entry: split.length > 1 ? split[1].toUpperCase() : ""
                            });
                        }
                    }

                    break;
                }
            }

            //#region function to append anchor element to the hyperlinks
            function append_hyperlink(text) {
                var res = text.match(/[\^].[^\^]*[\^]/gi);
                var result = "";
                if (res != null) {
                    for (var i = 0; i < res.length; i++) {
                        result = res[i].replace(/[/^]/g, "");
                        text = text.replace(
                            res[i],
                            "<a href='javascript:void(0)'>" + result + "</a>"
                        );
                    }
                }
                return text;
            }

            //#endregion

            //#region function to highlight the text which matches with the searchword
            function HighlightMatchedtext(text, type) {
                searchWord = searchWord.replace("|", "~");
                if (type !== "UTT" && type !== "KAT") {
                    if (!searchWord) return text;

                    // Escape regex special characters
                    const escaped = searchWord.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

                    // Allow optional ~ after each character (except space)
                    const pattern = [...escaped]
                        .map(char =>
                            char !== " " ? `${char}(?:~*)?` : char
                        )
                        .join("");

                    // Prevent matching inside HTML tags
                    const regex = new RegExp(
                        pattern + "(?![^<>]*>)",
                        "gi"
                    );

                    return text.replace(regex, "<span class=\"highlight\">$&</span>");
                } else {
                    return text;
                }
            }

            //#endregion

            //#region function to call the hyperlink and highlight function on the basis of condition
            function decode_utf8(text, type, imagethemePage, loaded) {
                if (text.includes("^")) {
                    text = append_hyperlink(text); //for hyperlink
                }
                if (!imagethemePage && !loaded) {
                    text = HighlightMatchedtext(text, type);
                }
                if (text.includes("&&") && text.includes("|")) {
                    text = text.split("|")[1];
                }
                //text = text.replace(/~/g, "|");
                //return text;
                text = text.replace(/~/g, "<span class='pipe-class'></span>");
                let parser = new DOMParser();
                let dom = parser.parseFromString('<!doctype html><body>' + text, 'text/html');
                if (dom.body.innerHTML.includes('&amp;')) {
                    return dom.body.innerHTML.replace(/&amp;/g, '&');
                } else {
                    return dom.body.innerHTML;
                }
            }

            //#endregion

            this.filterData(this.xres);
        },
        //#endregion

        //#region  function to get the content inside the span tag
        extractContent(s) {
            var span = document.createElement("span");
            span.innerHTML = s;
            return span.textContent || span.innerText;
        },
        //#endregion

        //#region function to send the sms text for picture page
        getName(val) {
            var splitText = val.split(" ")[0];
            splitText = splitText.split(";")[0];
            return splitText;
        },
        //#endregion

        //#region function to redirect to the picture page when clicked on image icon
        getImage(val1, val2, val3, val4) {
            var router = this.$router.resolve({
                name: "PictureComponent",
                params: {
                    id: val1,
                    wordtext: val2,
                    wordId: val3,
                    lang: val4,
                    isScrollTop: true,
                    dictionary: this.dictionary
                }
            });
            if (router.location.params.id === this.$route.params.id) {
                this.$eventBus.$emit(
                    "map-image",
                    {
                        id: val1,
                        wordtext: val2,
                        wordId: val3,
                        lang: val4,
                        isScrollTop: true,
                        dictionary: this.dictionary
                    }
                );
            } else {
                this.$router.push({
                    name: "PictureComponent",
                    params: {
                        id: val1,
                        wordtext: val2,
                        wordId: val3,
                        lang: val4,
                        isScrollTop: true,
                        dictionary: this.dictionary
                    }
                });
            }
        },
        //#endregion

        //#region function to append onclick event to the hyperlinks
        addOnClickToHyperlink() {
            var _this = this;
            var links = [];
            if (this.refElements !== undefined) {
                Object.keys(this.refElements).forEach(key =>
                    addlinks(this.refElements[key])
                );
                for (var i = 0; i < links.length; i++) {
                    if (links[i].tagName === "A") {
                        links[i].addEventListener("click", function (event) {
                            _this.$eventBus.$emit(
                                "send-temp",
                                event.currentTarget.text.trim()
                            );
                            if (_this.isPicturepage) {
                                localStorage.setItem(
                                    "searchWord",
                                    event.currentTarget.text.trim()
                                );
                                _this.$router.push({
                                    name: "FindwordsComponent",
                                    params: {dictionary: _this.dictionary, isSearch: true}
                                });
                            }
                        });
                    }
                }
            }

            function addlinks(elm) {
                if (
                    elm !== undefined &&
                    elm.children !== undefined &&
                    elm.children.length !== 0
                ) {
                    var arr = elm.children;
                    for (var j = 0; j < arr.length; j++) {
                        links.push(arr[j]);
                    }
                } else if (elm !== undefined) {
                    if (elm.length > 0) {
                        for (var i = 0; i < elm.length; i++) {
                            arr = elm[i].children;
                            for (j = 0; j < arr.length; j++) {
                                links.push(arr[j]);
                            }
                        }
                    }
                }
            }

            this.refElements = [];
            links = [];
        },
        //#endregion

        addClass(letter) {
            if (letter == 'y') {
                return 'underline_position';
            } else {
                return '';
            }
        },
        hasNorskOrdbank(languageCode) {
            let value = false;
            let ordbank = {};

            if (languageCode == 'nno') {
                if (this.NnyLem != undefined && this.listLength(this.NnyLem)) {
                    ordbank = this.getOrdbankResultByEMor(this.NnyLem);
                }
            } else if (this.lastLem != undefined && this.listLength(this.lastLem)) {
                ordbank = this.getOrdbankResultByEMor(this.lastLem);
            }

            if (this.listLength(ordbank) > 0) {
                value = true;
            }

            return value;
        },
        getNorskOrdbank(languageCode) {
            let ordbank = {};
            if (languageCode == 'nno') {
                if (this.NnyLem != undefined && this.listLength(this.NnyLem) > 0) {
                    ordbank = this.getOrdbankResultByEMor(this.NnyLem);
                }
            } else if (this.lastLem != undefined && this.listLength(this.lastLem) > 0) {
                ordbank = this.getOrdbankResultByEMor(this.lastLem);
            }

            return ordbank;
        },
        showLastOrdbank() {
            let value = false;
            if (this.lastLem != undefined && this.lastLem.lang != undefined &&
                this.lastLem.lang !== '' && this.lastLem.lang !== '-') {
                value = true;
            } else if (this.lastkat != undefined && this.lastkat.lang != undefined &&
                this.lastkat.lang != '' && this.lastkat.lang != '-') {
                value = true;
            }

            return value;
        },
        getResultIndex(postFix) {
            return this.resultIndex + '-' + postFix;
        },
        getDefaultOrdbankOpen(NnyLem, lastLem) {
            return false;
            // let value = true;
            // if ((typeof NnyLem == "object" && NnyLem.type != undefined) &&
            //     typeof lastLem == "object" && lastLem.type != undefined) {
            //     if (NnyLem.type == 'Nny-lem' &&
            //         (lastLem.type == 'E-lem' || lastLem.type == 'E-lem')) {
            //         value = false;
            //     }
            // }
            //
            // return value;
        },
        getOrdbankResultId(eLem) {
            let id = 0;
            if (typeof eMor == "object") {
                id = eMor.id || 0;
            }

            return id;
        },
        getOrdbankResultHasHeader(eLem) {
            let hasContent = false;
            let result = this.getOrdbankResultByEMor(eLem);
            if (result.ordklasse != undefined && result.ordklasse) {
                hasContent = true;
            }

            return hasContent;
        },
        getOrdbankResultHasContent(eLem) {
            let hasContent = false;
            let result = this.getOrdbankResultByEMor(eLem);
            if (result && result.has_content != undefined) {
                hasContent = result.has_content;
            }

            return hasContent;
        },

        getLangAttribute(languageCode) {
            let value = '';

            if (languageCode === 'last') {
                if (typeof this.lastLem == "object" && this.lastLem.lang != undefined) {
                    value = this.languageCodeList.find(x=>x.lang==this.lastLem.lang).langISOCode;
                } else if (typeof this.bLem == "object" && this.bLem.text != undefined) {
                    value = this.bLem.langISOCode;
                }
            } else if (languageCode === 'nob') {
                value = 'no';
            } else if (languageCode === 'nno') {
                value = 'nn';
            }

            return value;
        },
        getOrdbankInitialBlockInfo(languageCode) {

            let list = {
                'lem_info': {},
                'kat_info': {},
                'mor_info': {}
            };

            if (languageCode === 'last' || languageCode === 'nob') {

                if (typeof this.lastLem == "object" && this.lastLem.text != undefined) {
                    let langCode = this.lastLem.type.split('-')[0];
                    if (langCode === 'E' || langCode === 'N') {
                        languageCode = 'nob';
                    }

                    if (this.lastLem.text !== undefined) {
                        list['lem_info'] = this.lastLem || {};
                        list['kat_info'] = this.lastkat || {};
                        list['mor_info'] = this.lastMor || {};
                    }
                } else if (typeof this.bLem == "object" && this.bLem.text !== undefined) {
                    let langCode = this.bLem.type.split('-')[0];
                    if (langCode === 'B' && this.bLem.text !== undefined) {
                        list['lem_info'] = this.bLem || {};
                        list['kat_info'] = this.bKat || {};
                        list['mor_info'] = this.bMor || {};
                    }
                }
            } else if (languageCode === 'nno') {
                if (typeof this.NnyLem === "object" && this.NnyLem.text !== undefined) {
                    list['lem_info'] = this.NnyLem || {};
                    list['kat_info'] = this.NnyKat || {};
                    list['mor_info'] = this.NnyMor || {};
                }
            }

            if (languageCode === 'nob' || languageCode === 'nno') {
                list['norsk_ordbank'] = this.getOrdbankResultByEMor(list.lem_info);
                list['result_index'] = this.getResultIndex(languageCode);
            } else {
                list['norsk_ordbank'] = {};
                list['result_index'] = {};
            }
            list['sn_id'] = this.getSnId();
            list['part_of_speach_info'] = this.partOfSpeachInfo;
            list['language_code'] = languageCode;

            return list;
        },
        hasLanguageContent(lemInfo, languageCode = false) {
            let value = false;

            if (typeof lemInfo == "object" && lemInfo.type !== undefined) {
                if (languageCode == false) {
                    value = true;
                } else {
                    let lemInfoLang = lemInfo.type.split("-")[0];
                    if (languageCode == "nob" && (lemInfoLang == "N" || lemInfoLang == "E")) {
                        value = true
                    } else if (languageCode == "nno" && lemInfoLang == "Nny") {
                        value = true;
                    }
                }
            }

            return value;
        },
        getOrdbankResultByEMor(eLem) {
            let ordbankResult = {};
            if (typeof eLem == "object" && eLem.type != undefined) {
                let id = eLem.id || 0;
                let langCode = eLem.type.split("-")[0];
                if (this.cache['ord_result'] != undefined &&
                    this.cache['ord_result'][id] != undefined &&
                    this.cache['ord_result'][id][langCode] != undefined) {
                    ordbankResult = this.cache['ord_result'][id][langCode];
                } else {
                    let isoLangCode = "";
                    if (langCode == "Nny") {
                        isoLangCode = "nno";
                    } else if (langCode == "N" || langCode == "E") {
                        isoLangCode = "nob";
                    }

                    if (typeof this.ordbankList == "object" &&
                        isoLangCode in this.ordbankList &&
                        typeof this.ordbankList[isoLangCode] == "object" &&
                        id in this.ordbankList[isoLangCode]) {
                        ordbankResult = this.ordbankList[isoLangCode][id];
                    }

                    if (this.cache['ord_result'] == undefined) {
                        this.cache['ord_result'] = {};
                        this.cache['ord_result'][id] = {};
                    } else if (this.cache['ord_result'][id] == undefined) {
                        this.cache['ord_result'][id] = {};
                    }

                    this.cache['ord_result'][id][langCode] = ordbankResult;
                }
            }

            return ordbankResult;
        },
        getRedClassIfNonNorwegian(lastLem) {
            let value = "";

            if (typeof lastLem == "object" && lastLem.type != undefined) {
                let lang = lastLem.type.split("-")[0];
                if (lang == "N" || lang == "E" || lang == "Nny") {
                    value = "red";
                }
            }

            return value;
        },
        getIsNonNorwegian(lastLem) {
            let value = false;

            if (typeof lastLem == "object" && lastLem.type != undefined) {
                let lang = lastLem.type.split("-")[0];
                if (lang == "N" || lang == "E" || lang == "Nny") {
                    value = true;
                }
            }

            return value;
        },
        getSnId() {
            let value = 0;
            for (let i in this.Val) {
                if (this.Val[i]['id'] !== undefined && this.Val[i]['id'] > 0) {
                    return this.Val[i]['id'];
                }
            }

            return value;
        },
        hasTextProperty(objInfo) {
            let value = false;
            if (typeof objInfo == "object" && objInfo.text !== undefined && typeof objInfo.text == "string") {
                value = true;
            }

            return value;
        },
        listLength(list) {
            let value = 0;

            if (typeof list == "object" && Object.keys(list).length > 0) {
                value = Object.keys(list).length;
            }

            return value;
        }

        //#endregion
    }
};
</script>
<style>
</style>
